import { DataField } from '@formily/core'
import { useField } from '@formily/react'
import { Button } from 'antd'

import { ConfirmButton } from '@eastcoal/common/components/Button/ConfirmButton'

import { useArrayField } from '../../hooks/useArrayField'

import { RemoveButtonProps } from './interface'

export const RemoveButton = ({
  confirmMessage,
  danger = true,
  type = 'link',
  children = '删除',
  ...restProps
}: RemoveButtonProps) => {
  const field = useField<DataField>()
  const arrayField = useArrayField()

  const handleRemove = () => {
    arrayField.remove(field.index)
  }

  const requireConfirm = !!confirmMessage

  const button = (
    <Button
      danger={danger}
      type={type}
      onClick={requireConfirm ? undefined : handleRemove}
      {...restProps}
    >
      {children}
    </Button>
  )

  return confirmMessage ? (
    <ConfirmButton message={confirmMessage} onConfirm={handleRemove}>
      {button}
    </ConfirmButton>
  ) : (
    button
  )
}
